import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '代理店管理',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 4,
  rolesOnly: ['FCChina'],
  listed: true,
};
